import { createFileRoute } from '@tanstack/react-router'
import { ShieldOff } from 'lucide-react'
import { EmptyState } from '@/components/data/EmptyState'
import { PotsView } from '@/components/pots/PotsView'
import { useRoles } from '@/hooks/useRoles'

export const Route = createFileRoute('/pots')({
    component: PotsPage,
})

function PotsPage() {
    const { hasAnyRole } = useRoles()

    if (!hasAnyRole('admin')) {
        return (
            <EmptyState
                icon={ShieldOff}
                title="No access"
                description="Pot seeding is restricted to operators with the admin role."
            />
        )
    }

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-semibold">Prize pots</h1>
                <p className="text-muted-foreground text-sm">
                    Live per-game pot balances, with discretionary seeding through the whitelisted
                    BlockpotPotSeeder. The connected wallet needs SEEDER_ROLE to seed.
                </p>
            </div>
            <PotsView />
        </div>
    )
}
